<script setup lang="ts">
import { CustomerServiceProps } from "./CustomerService.props"
import { iconsSrcMap } from "./CustomerService.iconMapping"

withDefaults(defineProps<CustomerServiceProps>(), {
  text: "",
  iconType: "phone"
})

const dynamicId = computed(() => `link-${Math.random()}`)

const triggerLink = () => document.getElementById(dynamicId.value)?.click()
</script>

<template>
  <div
    @click="triggerLink"
    class="bg-white flex cursor-pointer gap-4 rounded-lg p-4 shadow-02"
  >
    <div
      v-if="iconType"
      class="
        bg-tiffany-10
        min-w-10
        flex
        h-full
        shrink-0
        items-center
        justify-center
        rounded
        p-2
      "
    >
      <UtilsIcon class="!w-10" v-bind="iconsSrcMap[iconType]" />
    </div>

    <div class="flex min-w-0 flex-col items-start">
      <p class="beaver-bold text-black-main">
        {{ title }}
      </p>

      <UtilsMarkdown
        v-if="text"
        class="mouse text-black-80 mb-4 mt-1"
        :content="text"
      />

      <UtilsButton
        v-if="contact"
        :id="dynamicId"
        :path="contact.link"
        class="
          contact
          custom-btn-underlined custom-btn-no-padding custom-btn-pig-medium
          inline-flex
        "
        :text="contact.label"
        theme="ghost-green"
        forceSelf
      />
    </div>
  </div>
</template>
